import React from 'react'
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import { Card, Button, Avatar, Alert } from 'antd';
import 'antd/dist/antd.css';
import { EyeOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { UserAuth } from '../context/AuthContext';

const Projects = () => {
  const navigate = useNavigate();
  const { user } = UserAuth();
  const userUID = user.uid;

  const [projectList, setProjectList] = useState([]);
  const [projectID, setProjectID] = useState("");


  // Listing all projects from the database once the page loads
  useEffect(() => {
    const q = query(collection(db, "projects"), orderBy("createdAt", "desc"));
    const querySnapshot = onSnapshot(q, (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        setProjectList((projectList) => [...projectList, doc.data()]);
        setProjectID((projectID) => [...projectID, doc.id]);


      });
    });
    return querySnapshot;
  }, [user]);


  const DocumentID = projectID[
    projectList.findIndex((project) => project.uid === userUID)

  ];


  // Duration of the project calculation
  const calculateDuration = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diff = end.getTime() - start.getTime();
    const days = diff / (1000 * 60 * 60 * 24);
    return `${days} days`;
  };


  function Cards() {
    return (
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {projectList.map((project) => (
          <div key={project.id} className="flex flex-col w-full h-64 border border-gray-200 rounded-md shadow-md sm:px-2 hover:shadow-lg hover:bg-gray-100">
            <div className="flex flex-col justify-start h-12 p-2  w-full">
              <div className="flex flex-row items-start">
                <img src='https://i.pravatar.cc/300' alt="Picture" className="bg-gray-200 w-12 h-12 rounded-full" />
                <div className="flex flex-col flex-grow ml-4 ">
                  <div className="text-lg font-bold">{project.title || 'Project Title Not Found'}</div>
                  <div className="text-sm text-gray-500">
                    {project.OwnerName || 'Creator Not Found'}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col flex-grow gap-0">
              <div className="flex flex-row justify-between h-12 pt-4 mr-3 border-cyan-800">
                <div className='text-lg font-bold ml-2 '>
                  {project.desiredRole || 'Role Not Found'}
                </div>
                <div className='text-md font-bold mr-2 '>{
                  calculateDuration(project.startDate, project.endDate)
                }</div>
              </div>
              <div className='flex flex-row'>
                <div className='text-md text-gray-500 ml-2'>
                  {project.description || 'Description Not Found'}
                </div>
              </div>
            </div>

            <div className="flex flex-row justify-between  h-12 p-2 mx-2 items-center">
              <div className="flex flex-row gap-2">
                <div className="text-sm text-gray-500"> Starting: {project.startDate || 'Start Date Not Found'}</div>
              </div>
              <div className="flex flex-row gap-2">
                <button className="flex flex-row gap-2 items-center justify-center px-4 py-2 text-sm font-medium text-black border rounded-md  focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                  <EyeOutlined />
                  <Link to={`/projects/${project.projectID}`}>
                    <span className="text-sm text-black font-medium">View</span>
                  </Link>
                </button>
              </div>
            </div>

          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center mx-5">
      <div className="flex flex-row items-center p-5 justify-between w-full">
        <h1 className="text-3xl font-bold">Featured Projects</h1>
        <Button type="primary" onClick={() => navigate('/add-new-project')}>Create Project</Button>
      </div>
      <Cards />
    </div>
  )
}

export default Projects